import Choices from 'choices.js';

// Inicializar Choices sobre un select específico
document.addEventListener('DOMContentLoaded', () => {
  const selects = document.querySelectorAll('.tasaciones-scope select.tasaciones-select');

  selects.forEach((select) => {
    new Choices(select, {
      searchEnabled: false,
      itemSelectText: '',
      shouldSort: false,
      placeholderValue: select.getAttribute('placeholder') || 'Selecciona una opción',
    });
  });
});